import React, { useState } from "react";
import Menu from "./Menu";
import Categories from "./Categories";
import items from "./data";

function App() {
  const allCategories = ["all", ...new Set(items.map((item) => item.category))];
  const [menuItems, setMenuItems] = useState(items);
  const [menuCategories, setMenuCategories] = useState(allCategories);

  const filterItems = (category) => {
    if (category === "all") {
      setMenuItems(items);
      return;
    }
    let newItems = items.filter((menuItem) => {
      return menuItem.category === category;
    });
    setMenuItems(newItems);
  };

  return (
    <main>
      <section className="menu section">
        <div className="title">
          <h3>Our Menu</h3>
          <div className="underline"></div>
          <Categories
            filterItems={filterItems}
            menuCategories={menuCategories}
          />
          <Menu items={menuItems} />
        </div>
      </section>
    </main>
  );
}

export default App;
